export const app = {
  title: 'MESAHIST',
  tab: {
    registry: 'Реестр',
    faces: 'Внешки',
    character: 'Персонаж',
    tasks: 'Задачи',
    more: 'Ещё',
  },

  boot: {
    loading: 'Проверяем, кто пришёл',
    error: 'Не получилось войти',
  },
} as const;
